import { CONTAINER_ID } from '../engage-constants';

export const DEVICE_TYPE_TO_HEIGHT_MAP: Record<
  'DESKTOP' | 'MOBILE' | 'NONE',
  string
> = {
  DESKTOP: 'calc(100vh - 56px)',
  MOBILE: 'calc(100vh - 120px)',
  NONE: '100%',
};

export const setContainerHeight = (
  deviceType?: 'DESKTOP' | 'MOBILE' | 'NONE'
) => {
  const containerDOMElement = document.getElementById(CONTAINER_ID);

  if (!containerDOMElement) return;

  if (deviceType) {
    containerDOMElement.style.height = DEVICE_TYPE_TO_HEIGHT_MAP[deviceType];
    return;
  }

  const currentHeight = containerDOMElement.style.height;

  if (window.innerWidth < 960 && currentHeight.includes('56')) {
    containerDOMElement.style.height = DEVICE_TYPE_TO_HEIGHT_MAP['MOBILE'];
    return;
  }

  if (window.innerWidth > 959 && currentHeight.includes('120')) {
    containerDOMElement.style.height = DEVICE_TYPE_TO_HEIGHT_MAP['DESKTOP'];
    return;
  }

  containerDOMElement.style.height = DEVICE_TYPE_TO_HEIGHT_MAP['NONE'];
};

export const resizeContainer = (event) => setContainerHeight();

export const setInitialProfile = (isLoggedIn: boolean) => {
  if (isLoggedIn) {
    setContainerHeight();
  }
  setContainerHeight('NONE');
};
